export default function Events() {
  const events = [
    {
      title: 'Trivia Night',
      day: 'Every Tuesday',
      time: '7:00 PM - 9:00 PM',
      icon: 'ri-question-line',
      color: 'cyan',
      description: 'Test your knowledge across pop culture, gaming, and random facts. Prizes for top teams!'
    },
    {
      title: 'Throwback Tournament Night',
      day: 'Every Thursday',
      time: '8:00 PM - 11:00 PM',
      icon: 'ri-trophy-line',
      color: 'pink',
      description: 'Compete in classic arcade tournaments. Street Fighter, NBA Jam, and more. Winners get bragging rights and free drinks!'
    },
    {
      title: 'Karaoke / DJ Night',
      day: 'Friday & Saturday',
      time: '9:00 PM - 1:00 AM',
      icon: 'ri-music-line',
      color: 'orange',
      description: 'Sing your heart out or dance the night away with live DJ sets and karaoke battles.'
    },
    {
      title: 'Happy Hour',
      day: 'Monday - Friday',
      time: '4:00 PM - 7:00 PM',
      icon: 'ri-time-line',
      color: 'cyan',
      description: '$2 off all drinks and appetizers. The perfect way to unwind after work.'
    }
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="events" className="relative py-24 px-4 sm:px-6 lg:px-8">
      <div className="absolute inset-0 bg-[#0a1628]">
        <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, #ec4899 10px, #ec4899 20px)' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-cyan-400 mb-4">
            Weekly Events
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-pink-500 to-cyan-500 mx-auto mb-6"></div>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Something exciting happening every night of the week
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {events.map((event, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-[#0d1f3c] to-[#0a1628] rounded-xl p-8 border-2 border-cyan-500/20 hover:border-pink-500/50 transition-all duration-300 hover:shadow-[0_0_40px_rgba(236,72,153,0.3)] hover:-translate-y-1"
            >
              {/* Corner accents */}
              <div className="absolute top-2 left-2 w-6 h-6 border-t-4 border-l-4 border-cyan-400 opacity-50"></div>
              <div className="absolute bottom-2 right-2 w-6 h-6 border-b-4 border-r-4 border-pink-400 opacity-50"></div>

              <div className="flex items-start mb-6">
                <div className={`w-16 h-16 flex items-center justify-center bg-${event.color}-500/20 rounded-lg mr-4 flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${event.icon} text-3xl text-${event.color}-400`}></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-cyan-400 transition-colors duration-300">
                    {event.title}
                  </h3>
                  <div className="flex flex-col space-y-1">
                    <span className="text-pink-400 font-bold text-sm">{event.day}</span>
                    <span className="text-gray-400 text-sm">{event.time}</span>
                  </div>
                </div>
              </div>

              <p className="text-gray-300 leading-relaxed">
                {event.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={() => scrollToSection('contact')}
            className="group relative px-10 py-4 bg-transparent border-2 border-pink-500 text-pink-400 text-lg font-bold rounded-lg overflow-hidden transition-all duration-300 hover:shadow-[0_0_30px_rgba(236,72,153,0.6)] hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="relative z-10">View Events Calendar</span>
            <div className="absolute inset-0 bg-pink-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </button>
        </div>
      </div>
    </section>
  );
}
